import React from "react";

export const Panel = ({ overline, title, children, className = "", testid }) => (
  <section className={`border border-border bg-card rounded-sm p-5 md:p-7 ${className}`} data-testid={testid}>
    {overline && <div className="overline text-primary">{overline}</div>}
    {title && <h2 className="font-display font-bold text-lg md:text-xl tracking-tight mt-1 mb-5">{title}</h2>}
    {children}
  </section>
);

export const NumField = ({ label, value, onChange, suffix, hint, testid, step = "any" }) => (
  <label className="block">
    <span className="text-xs font-mono-plex uppercase tracking-widest text-muted-foreground">{label}</span>
    <div className="mt-1.5 flex items-center border border-input bg-background rounded-sm focus-within:border-primary transition-colors">
      <input
        type="number" inputMode="decimal" min="0" step={step} value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent px-3 h-11 text-base outline-none"
        data-testid={testid}
      />
      {suffix && <span className="px-3 text-xs text-muted-foreground font-mono-plex whitespace-nowrap">{suffix}</span>}
    </div>
    {hint && <span className="text-xs text-muted-foreground mt-1 block">{hint}</span>}
  </label>
);

export const TextField = ({ label, value, onChange, testid, multiline, placeholder, rows = 3, type = "text" }) => (
  <label className="block">
    <span className="text-xs font-mono-plex uppercase tracking-widest text-muted-foreground">{label}</span>
    {multiline ? (
      <textarea
        rows={rows} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 w-full border border-input bg-background rounded-sm px-3 py-2 text-sm outline-none focus:border-primary transition-colors"
        data-testid={testid}
      />
    ) : (
      <input
        type={type} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}
        className="mt-1.5 w-full border border-input bg-background rounded-sm px-3 h-11 [color-scheme:dark] print:[color-scheme:light] text-sm outline-none focus:border-primary transition-colors"
        data-testid={testid}
      />
    )}
  </label>
);

export const SelectField = ({ label, value, onChange, options, testid }) => (
  <label className="block">
    <span className="text-xs font-mono-plex uppercase tracking-widest text-muted-foreground">{label}</span>
    <select
      value={value} onChange={(e) => onChange(e.target.value)}
      className="mt-1.5 w-full border border-input bg-background rounded-sm px-3 h-11 text-sm outline-none focus:border-primary"
      data-testid={testid}
    >
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </label>
);

export const Stat = ({ label, value, sub, tone = "", testid, big }) => (
  <div className="border border-border bg-background rounded-sm p-4">
    <div className="text-xs font-mono-plex uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className={`font-display font-black tracking-tight mt-1 ${big ? "text-5xl md:text-6xl" : "text-2xl md:text-3xl"} ${tone}`} data-testid={testid}>{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
  </div>
);
